"use client";

import React from "react";
import { ArrowRight, Building2, Clock, Mail, MapPin, Navigation, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
const officeDetails = [{
  title: "Office",
  value: <>
        400-1186 Roland St.
        <br />
        Thunder Bay, Ontario
        <br />
        P7B 5M4
      </>,
  icon: MapPin
}, {
  title: "Hours",
  value: "Monday to Friday, 8:00 AM to 5:00 PM",
  icon: Clock
}, {
  title: "Phone",
  value: "(807) 935-7952",
  icon: Phone,
  href: "tel:+18079357952"
}, {
  title: "Email",
  value: "info@riverbendcorp.ca",
  icon: Mail,
  href: "mailto:info@riverbendcorp.ca"
}];
export default function VisitUsToday() {
  return <section data-section-id="131200" id="our-thunder-bay-location" className="relative bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div id="connect-with-our-office" className="absolute top-0 left-0" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(53,128,121,0.08),transparent_38%)] pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(17,47,75,0.05),transparent_42%)] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 xl:gap-16 items-center">
          <div className="lg:col-span-5">
            <p className="text-secondary font-default font-bold tracking-widest uppercase text-sm mb-4">
              Thunder Bay Office
            </p>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary-500 leading-tight mb-6">
              Local office, practical support, and a clear next step.
            </h2>

            <p className="text-lg text-muted-foreground font-default leading-relaxed mb-8">
              RiverBend is based in Thunder Bay and supports First Nation
              communities, Northern organizations, businesses, and partnerships
              with financial management, reporting, project support, systems,
              and advisory work.
            </p>

            <div className="rounded-2xl border border-secondary/20 bg-secondary/10 p-6">
              <div className="flex items-start gap-4">
                <div className="size-12 rounded-md bg-secondary/10 flex items-center justify-center shrink-0">
                  <Building2 className="size-6 text-secondary" />
                </div>

                <div>
                  <h3 className="text-xl font-default font-bold text-primary-500 mb-2">
                    Planning to reach out?
                  </h3>

                  <p className="text-muted-foreground font-default leading-relaxed">
                    A short note about your organization, the issue you are
                    facing, and the type of support you need is enough to begin
                    the conversation. We can follow up for more details if the
                    work may be a fit.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <Card className="border-border shadow-xl rounded-2xl bg-card overflow-hidden">
              <CardContent className="p-0">
                <div className="grid grid-cols-1 md:grid-cols-2">
                  <div className="p-8 md:p-10 bg-primary-500 text-primary-foreground">
                    <div className="size-12 rounded-md bg-white/10 flex items-center justify-center mb-6">
                      <MapPin className="size-6 text-secondary-100" />
                    </div>

                    <h3 className="text-2xl md:text-3xl font-default font-bold text-white mb-4">
                      RiverBend Accounting & Management Services
                    </h3>

                    <p className="text-primary-foreground/85 font-default leading-relaxed mb-8">
                      Our office is located in Thunder Bay, with client support
                      provided through a combination of in-office work, remote
                      communication, and client-community travel when required.
                    </p>

                    <Button asChild size="lg" variant="secondary" className="h-12 px-8 rounded-md font-default">
                      <Link to="https://www.google.com/maps/search/?api=1&query=400-1186+Roland+St+Thunder+Bay+Ontario+P7B+5M4" newTab>
                        <Navigation className="mr-2 size-4" />
                        Open in Maps
                      </Link>
                    </Button>
                  </div>

                  <div className="p-8 md:p-10">
                    <div className="space-y-5">
                      {officeDetails.map((item, index) => {
                      const Icon = item.icon;
                      const content = <div className="rounded-lg border border-border bg-background p-5 flex items-start gap-4 hover:border-secondary/40 transition-colors">
                            <div className="size-11 rounded-md bg-secondary/10 flex items-center justify-center shrink-0">
                              <Icon className="size-5 text-secondary" />
                            </div>

                            <div>
                              <p className="text-sm font-default font-bold uppercase tracking-wider text-muted-foreground mb-1">
                                {item.title}
                              </p>

                              <p className="text-primary-500 font-default font-bold leading-relaxed">
                                {item.value}
                              </p>
                            </div>
                          </div>;
                      if (item.href) {
                        return <Link key={item.title} to={item.href}>
                              {content}
                            </Link>;
                      }
                      return <div key={item.title} data-index={index}>
                            {content}
                          </div>;
                    })}
                    </div>

                    <div className="mt-8">
                      <Button asChild size="lg" className="w-full h-12 rounded-md bg-secondary hover:bg-secondary/90 text-white font-default">
                        <Link to="#connect-with-our-office">
                          Send an Inquiry
                          <ArrowRight className="ml-2 size-4" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}